import { z, isoZ } from 'my-zod'

export const partFragment = z.object({
  id: z.string().uuid(),
  damageWaiverPartOrderId: z.string().uuid(),
  partNumber: z.string().max(50).nonempty(),
  quantity: z.number().min(0),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant()
})
